import { useState } from "react";
import "./rs-change.styles.scss";
import {
  passwordChangeInitial,
  nameChangeInitial,
  emailChangeInitial,
  handleChange,
  changePassword,
  changeName,
  changeEmail,
} from "./rs-change.utils";
const RSChange = () => {
  const [passwordFields, setPasswordFields] = useState(passwordChangeInitial);
  const [nameFields, setNameFields] = useState(nameChangeInitial);
  const [emailFields, setEmailFields] = useState(emailChangeInitial);
  const { currentPassword, newPassword, confirmPassword } = passwordFields;
  const { currentName, newName, confirmName } = nameFields;
  const { currentEmail, newEmail, confirmEmail } = emailFields;
  return (
    <div className="rs-change-container">
      <div className="rs-change-box">
        <span className="rs-change-box-title">Change Restuarant Name</span>
        <form onSubmit={(event) => changeName(event, nameFields)}>
          <input
            type="text"
            className="rs-change-input"
            name="currentName"
            value={currentName}
            placeholder="Current Restaurant Name"
            onChange={(event) => handleChange(event, setNameFields, nameFields)}
          />
          <input
            type="text"
            name="newName"
            value={newName}
            placeholder="New Restaurant Name"
            className="rs-change-input"
            onChange={(event) => handleChange(event, setNameFields, nameFields)}
          />
          <input
            type="text"
            value={confirmName}
            name="confirmName"
            placeholder="Confirm New Name"
            className="rs-change-input"
            onChange={(event) => handleChange(event, setNameFields, nameFields)}
          />
          <button type="submit" className="rs-submit">
            Change Name
          </button>
        </form>
      </div>
      <div className="rs-change-box">
        <span className="rs-change-box-title">Change Admin Email</span>
        <form onSubmit={(event) => changeEmail(event, emailFields)}>
          <input
            type="text"
            value={currentEmail}
            name="currentEmail"
            placeholder="Current Email address"
            className="rs-change-input"
            onChange={(event) =>
              handleChange(event, setEmailFields, emailFields)
            }
          />
          <input
            type="text"
            value={newEmail}
            name="newEmail"
            placeholder="New Email address"
            className="rs-change-input"
            onChange={(event) =>
              handleChange(event, setEmailFields, emailFields)
            }
          />
          <input
            type="text"
            value={confirmEmail}
            name="confirmEmail"
            placeholder="Confirm Email address"
            className="rs-change-input"
            onChange={(event) =>
              handleChange(event, setEmailFields, emailFields)
            }
          />
          <button type="submit" className="rs-submit">
            Change Email
          </button>
        </form>
      </div>
      <div className="rs-change-box">
        <span className="rs-change-box-title">Change Password</span>
        <form onSubmit={(event) => changePassword(event, passwordFields)}>
          <input
            type="password"
            value={currentPassword}
            name="currentPassword"
            placeholder="Current Password"
            className="rs-change-input"
            onChange={(event) =>
              handleChange(event, setPasswordFields, passwordFields)
            }
          />
          <input
            type="password"
            value={newPassword}
            name="newPassword"
            placeholder="New Password"
            className="rs-change-input"
            onChange={(event) =>
              handleChange(event, setPasswordFields, passwordFields)
            }
          />
          <input
            type="password"
            value={confirmPassword}
            name="confirmPassword"
            placeholder="Confirm Password"
            className="rs-change-input"
            onChange={(event) =>
              handleChange(event, setPasswordFields, passwordFields)
            }
          />

          <button type="submit" className="rs-submit">
            Change Password
          </button>
        </form>
      </div>
    </div>
  );
};
export default RSChange;
